import { TeamsState } from './state';

export const teamsInitialState: TeamsState = {
  teamMembers: [],
};
